/**
 * Módulo: Busca
 * Abre/fecha o modal de busca (template-parts/UI/search-modal.php).
 * Gatilhos: qualquer [data-search-open]; fecha com [data-search-close] ou Esc.
 */

export function initSearch() {
  const modal = document.getElementById("search-modal");
  if (!modal) return;

  const input    = modal.querySelector(".search-form__input");
  const triggers = document.querySelectorAll("[data-search-open]");
  let lastTrigger    = null;
  let prevOverflow   = "";

  function open(trigger) {
    lastTrigger  = trigger || null;
    prevOverflow = document.body.style.overflow;

    modal.removeAttribute("inert");
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
    triggers.forEach((t) => t.setAttribute("aria-expanded", "true"));

    // Espera o painel ficar visível para o foco funcionar
    requestAnimationFrame(() => {
      input?.focus();
      input?.select();
    });
  }

  function close() {
    if (!modal.classList.contains("is-open")) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("inert", "");
    // Mantém o overflow do overlay mobile se a busca foi aberta por dentro dele
    document.body.style.overflow = prevOverflow;
    triggers.forEach((t) => t.setAttribute("aria-expanded", "false"));
    lastTrigger?.focus();
  }

  triggers.forEach((trigger) => {
    trigger.setAttribute("aria-expanded", "false");
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      open(trigger);
    });
  });

  modal.querySelectorAll("[data-search-close]").forEach((btn) => {
    btn.addEventListener("click", close);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !modal.classList.contains("is-open")) return;
    // Não deixa o Esc também fechar o overlay mobile que está por baixo
    e.stopImmediatePropagation();
    close();
  }, true);

  // Mantém o Tab dentro do modal
  modal.addEventListener("keydown", (e) => {
    if (e.key !== "Tab") return;

    const focusables = modal.querySelectorAll(
      "input:not([type=hidden]), button, a[href]"
    );
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
}
